import { render } from "./TextReader.vue?vue&type=template&id=994c367c&scoped=true"
import script from "./TextReader.vue?vue&type=script&lang=js"
export * from "./TextReader.vue?vue&type=script&lang=js"

import "./TextReader.vue?vue&type=style&index=0&id=994c367c&scoped=true&lang=scss"
import "./TextReader.vue?vue&type=style&index=1&id=994c367c&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-994c367c"]])

export default __exports__